export const WINDOW_DESKTOP_MEDIUM = 1165;
export const WINDOW_MOBILE_LARGE = 720;
export const WINDOW_MOBILE_MEDIUM = 480;

export const DRAWER_EXTRA_LARGE = 600;
export const DRAWER_LARGE = 500;
export const DRAWER_MEDIUM = 400;
export const DRAWER_SMALL = 350;
